import { Box, Typography } from '@mui/material';
import React from 'react';
import MILISTONEICON from '../../../../../Assets/Images/milistone.png'
import CHECKICON from '../../../../../Assets/Images/Share.png'
import STARICON from '../../../../../Assets/Images/star.png'
import SubscriptionICON from '../../../../../Assets/Images/subscribtionIcon.png'
const IntpreterMilestoneAchievement = (props) => {
    const { interpreterMilestone, isLoading , interpreterPlan} = props;
    console.log('interpreterMilestone', interpreterMilestone);

    return (
        <Box sx={{
            width: '100%',
            padding: '20px 0px 20px 0px'
            // height: 'calc(100vh - 170px)',
        }}>
            <Typography
                sx={{
                    fontSize: "20px",
                    fontWeight: "500",
                    fontFamily: 'Outfit',
                    color: "rgba(0, 151, 178, 1)",
                    paddingBottom: '15px'
                }}>
                Milestone Achievement
            </Typography>
            <Box sx={{
                background: "rgba(250, 250, 250, 1)",
                border: "1px solid rgba(8, 85, 127, 0.2)",
                padding: '15px',
                borderRadius: '15px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gridGap: '10px',
                width: 'fit-content',
            }}>
                <Box sx={{
                    width: '103px',
                }}>
                    <Box sx={{
                        width: '103px'
                    }}>
                        <img src={MILISTONEICON} alt='milestone' style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        }} />
                    </Box>
                </Box>
                <Box sx={{
                    width: 'calc(100% - 113px)'
                }}>
                    <Box sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        gridGap: '10px',
                        width: '100%',
                    }}>
                        <img src={CHECKICON} alt='milestone' style={{
                            width: '18px',
                            height: '18px',
                            objectFit: 'cover'
                        }} />
                        <Typography sx={{ fontSize: "16px", fontWeight: "500", fontFamily: 'Outfit', color: "#000" }}>
                            Milestone Achievement: <span style={{
                                fontSize: '14px',
                                fontWeight: '400',
                                color: "#000"
                            }}>{interpreterMilestone?.completed_session || 0}</span>
                        </Typography>
                    </Box>
                    <Box sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        gridGap: '10px',
                        width: '100%',
                    }}>
                        <img src={CHECKICON} alt='milestone' style={{
                            width: '18px',
                            height: '18px',
                            objectFit: 'cover'
                        }} />
                        <Typography sx={{ fontSize: "16px", fontWeight: "500", fontFamily: 'Outfit', color: "#000" }}>
                            Total Hours Worked: <span style={{
                                fontSize: '14px',
                                fontWeight: '400',
                                color: "#000"
                            }}>{interpreterMilestone?.total_work_hours || "-"} Hours</span>
                        </Typography>

                    </Box>
                    <Box sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        gridGap: '10px',
                        width: '100%',
                    }}>
                        <img src={CHECKICON} alt='milestone' style={{
                            width: '18px',
                            height: '18px',
                            objectFit: 'cover'
                        }} />
                        <Typography sx={{ fontSize: "16px", fontWeight: "500", fontFamily: 'Outfit', color: "#000" }}>
                            Top Language Pair: <span style={{
                                fontSize: '14px',
                                fontWeight: '400',
                                color: "#000"
                            }}>{interpreterMilestone?.language_pair && interpreterMilestone?.language_pair?.from_language || "N/A"} → {interpreterMilestone?.language_pair?.to_language || "N/A"}</span>
                        </Typography>
                    </Box>
                    <Box sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        gridGap: '10px',
                        width: '100%',
                    }}>
                        <img src={CHECKICON} alt='milestone' style={{
                            width: '18px',
                            height: '18px',
                            objectFit: 'cover'
                        }} />
                        <Typography
                            sx={{
                                fontSize: "16px",
                                fontWeight: "500",
                                fontFamily: 'Outfit',
                                color: "#000",
                                display: 'flex'
                            }}>
                            Client Rating:  <img src={STARICON} alt='milestone' style={{
                                width: '18px',
                                height: '18px',
                                objectFit: 'cover'
                            }} /> <span style={{
                                fontSize: '14px',
                                fontWeight: '400',
                                color: "#000"
                            }}>{interpreterMilestone?.rating || 0}/5</span>
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <Typography
                sx={{
                    fontSize: "20px",
                    fontWeight: "500",
                    fontFamily: 'Outfit',
                    color: "rgba(0, 151, 178, 1)",
                    padding: '15px 0px'
                }}>
                Subscription Details
            </Typography>
            {interpreterPlan !== null && <Box sx={{
                background: "rgba(250, 250, 250, 1)",
                border: "1px solid rgba(8, 85, 127, 0.2)",
                padding: '15px',
                borderRadius: '15px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gridGap: '10px',
                width: 'fit-content',
            }}>
                <Box sx={{
                    width: '74px',
                }}>
                    <Box sx={{
                        width: '74px'
                    }}>
                        <img src={SubscriptionICON} alt='milestone' style={{
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover'
                        }} />
                    </Box>
                </Box>
                <Box sx={{
                    width: 'calc(100% - 84px)'
                }}>
                    <Box sx={{
                        width: '100%',
                    }}>
                        <Typography sx={{ fontSize: "16px", fontWeight: "500", fontFamily: 'Outfit', color: "#000" }}>
                            {interpreterPlan?.price === 2000 ? "Basic Plan" : "Pro Plan"}
                        </Typography>
                        <Typography sx={{ fontSize: "18px", fontWeight: "500", fontFamily: 'Outfit', color: "rgba(8, 85, 127, 1)" }}>
                            $19.99 <span style={{
                                fontSize: '14px',
                                fontWeight: '400',
                                color: "rgba(8, 85, 127, 1)"
                            }}>{interpreterPlan?.price === 2000 ? "/Monthly" : "/Yealry"}</span>
                        </Typography>
                    </Box>

                </Box>
            </Box>}
        </Box>
    );
};

export default IntpreterMilestoneAchievement;